/* eslint-disable import/no-cycle */
import { log } from '@/utils/common';
import { http } from '../utils/http';

async function getProducts(searchText) {
  try {
    log('productApi::getProducts');
    let url = '/products?brandType=BOTALAB';
    if (searchText) {
      url += `&title=${searchText}`;
    }
    const { data } = await http.get(url);
    return data;
  } catch (e) {
    // eslint-disable-next-line no-alert
    alert('처리 중 에러가 발생하였습니다.');
    return {
      error: e,
    };
  }
}

async function getProductDetail(productId) {
  try {
    log('productApi::getProductDetail');
    const obj = await http.get(`/products/detail/${productId}`);
    return obj;
  } catch (e) {
    // eslint-disable-next-line no-alert
    alert('처리 중 에러가 발생하였습니다.');
    return {
      error: e,
    };
  }
}

async function getMainProductList() {
  try {
    log('productApi::getMainProductList');
    const { data } = await http.get('/products/main/BOTALAB');
    return data;
  } catch (e) {
    // eslint-disable-next-line no-alert
    alert('처리 중 에러가 발생하였습니다.');
    return {
      error: e,
    };
  }
}
export default {
  getProducts,
  getProductDetail,
  getMainProductList,
};
